var _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoList2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 51,
    viewBox: "0 0 61 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.499987 0.5L0.5 50.5",
    stroke: "#CED4DA",
    strokeLinecap: "square"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 60.5,
    y1: 24.5,
    x2: 1.5,
    y2: 24.5,
    stroke: "#CED4DA",
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoList2);
export default __webpack_public_path__ + "static/media/ico-list2.846908cae77c69a3790459b579f04f28.svg";
export { ForwardRef as ReactComponent };